/**
 * WebGL関係の設定値を管理するファイル
 */

import { WebGLRenderer, Scene } from "three";

import Camera from "@/webgl/common/Camera";
import Controls from "@/webgl/common/Controls";
import RoomRaycaster from "@/webgl/common/RoomRaycaster";
import NodeIconContainer from "@/webgl/room/NodeIconContainer";

const canvas = document.createElement("canvas");
const DEF_METER_PER_PIXEL = 0.02;

export default {
  namespaced: true,
  state: {
    canvas,
    meterPerPixel: DEF_METER_PER_PIXEL,
    renderer: new WebGLRenderer({
      alpha: true,
      antialias: true,
      canvas: canvas
    }),
    scene: new Scene(),
    camera: new Camera(),
    controls: new Controls(),
    raycaster: new RoomRaycaster(),
    nodeIconContainer: new NodeIconContainer()
  },
  mutations: {
    toggleCameraMode(state) {
      if (state.camera.mode === "firstPerson") {
        state.camera.mode = "thirdPerson";
      } else if (state.camera.mode === "thirdPerson") {
        state.camera.mode = "firstPerson";
      }
    },
    setMeterPerPixel(state, value) {
      state.meterPerPixel = value;
    }
  }
};
